var map = {
	"./assets-3-lvyou.png": "Z7E0",
	"./bank.png": "iuS/",
	"./bus-station.png": "WklN",
	"./cemetery.png": "ajig",
	"./coffee.png": "QX6l",
	"./crops.png": "1wgY",
	"./entertainment.png": "kX2M",
	"./factory.png": "Dr8M",
	"./farm.png": "8/rD",
	"./farmers-library.png": "YUwf",
	"./fast-food.png": "SuZI",
	"./fishery.png": "umnl",
	"./hospital.png": "qab5",
	"./import-export.png": "+GlQ",
	"./kindergarten.png": "Zcfv",
	"./logistics-center.png": "0o92",
	"./mansion.png": "WuYm",
	"./medicamentarius.png": "3VCl",
	"./meeting-duty.png": "OJmf",
	"./meeting-other.png": "XPqV",
	"./meeting.png": "Z/EU",
	"./middle-school.png": "8PL2",
	"./nursing-home.png": "XxYH",
	"./other.png": "7n6u",
	"./p.png": "IyPm",
	"./park.png": "N7za",
	"./petrol-station.png": "AXMt",
	"./primary-industry.png": "8tYZ",
	"./primary-school.png": "WCNl",
	"./recreation-sports.png": "Z6cL",
	"./restaurant.png": "qptH",
	"./secondary-industry.png": "fhWK",
	"./service-center-agriculture.png": "2p1F",
	"./service.png": "e1B+",
	"./shop.png": "u6K6",
	"./shopping-center.png": "jwSr",
	"./sign.png": "1Vgv",
	"./sports.png": "Esmo",
	"./spuermarker.png": "yeCO",
	"./tertiary-industry.png": "Hhnc",
	"./tourism.png": "lZfU",
	"./village-committee.png": "Gr9M",
	"./village-public-bar.png": "PPhF"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Ged7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/city-map/icon ^\.\/.*\.png$
// module id = Ged7
// module chunks = 289